import { useState } from "react"
import MarkAttendance from "../modals/MarkAttendance"
import { CardStat } from "./CardComps"
import { CardContainer } from "./CardContainer"
import { Button } from "@mui/material"
import TakeAttendance from "../modals/TakeAttendance"

export const ClassCard = () => {
  const [markAttendance, setMarkAttendance] = useState(false)

  const openMarkAttendance = () => setMarkAttendance(true)
  const closeMarkAttendance = () => setMarkAttendance(false)

  const [takeAttendance, setTakeAttendance] = useState(false)

  const openTakeAttendance = () => setTakeAttendance(true)
  const closeTakeAttendance = () => setTakeAttendance(false)

  return (
    <>
      <CardContainer
        SummaryContent={
          <>
            <CardStat label="Course" value="Course 1" />
            <CardStat label="Batch" value="Batch 1" />
            <CardStat label="Topic" value="Topic Name" />
            <CardStat label="Schedule" value="6:30 PM 18 Jun, 2022" />{" "}
          </>
        }
        ActionButtons={
          true ? (
            <Button onClick={openTakeAttendance} variant="contained">
              Take Attendance
            </Button>
          ) : (
            <Button onClick={openMarkAttendance} variant="contained">
              Mark Attendance
            </Button>
          )
        }
        DetailsContent={
          <>
            <CardStat
              label="Chapter(s)"
              value="Chapter 1, Chapter 2, Chapter 3, Chapter 4"
            />
            <CardStat label="Teacher" value="Mr. Rakesh Roshan" />
          </>
        }
        cardTitle={"Course 1"}
        disableEditDelete
      />
      <TakeAttendance isOpen={takeAttendance} close={closeTakeAttendance} />
      <MarkAttendance isOpen={markAttendance} close={closeMarkAttendance} />
    </>
  )
}
